var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.142,
    height: 14.142,
    viewBox: "0 0 14.142 14.142",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_861",
    "data-name": "Group 861",
    transform: "translate(-576.822 -2024.623) rotate(45)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_90",
    "data-name": "Line 90",
    x2: 18,
    transform: "translate(1840.5 1023.75)",
    fill: "none",
    stroke: "#0a1e5b",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_91",
    "data-name": "Line 91",
    x2: 16.5,
    transform: "translate(1849.5 1015.5) rotate(90)",
    fill: "none",
    stroke: "#0a1e5b",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.135dc38f28395cd4ceebe0376551436e.svg";
export { ForwardRef as ReactComponent };